import { Capacitor } from "@capacitor/core";
import { api } from "./api";

// Push natif (APNs iOS / FCM Android) via Capacitor. Entièrement no-op sur le
// web : la PWA continue d'utiliser le web-push (VAPID) existant.

let lastToken = null;
let listenersAdded = false;

export async function registerNativePush() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");

    if (!listenersAdded) {
      listenersAdded = true;
      PushNotifications.addListener("registration", async (token) => {
        lastToken = token.value;
        try {
          await api.post("/push/devices", {
            token: token.value,
            platform: Capacitor.getPlatform(),
          });
        } catch { /* best-effort : réessayé au prochain lancement */ }
      });
      PushNotifications.addListener("registrationError", () => {});
    }

    let perm = await PushNotifications.checkPermissions();
    if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
      perm = await PushNotifications.requestPermissions();
    }
    if (perm.receive !== "granted") return;
    await PushNotifications.register();
  } catch { /* plugin indisponible : on ignore */ }
}

export async function unregisterNativePush() {
  if (!Capacitor.isNativePlatform() || !lastToken) return;
  try {
    // Appelé avant tokens.clear() : la requête part encore authentifiée.
    await api.post("/push/devices/unregister", { token: lastToken });
  } catch { /* noop */ }
  lastToken = null;
}
